import { IConvertedRegionItem, ILanguageConfig, IRegionCountryListItem } from './types';

/**
 * @Author: Long Wang
 * @description: 转换语言列表
 * @param {*} data
 * @param {*} languageConfigs
 * @return {*}
 */
export function convertLanguageLists(data: IRegionCountryListItem[], languageConfigs: ILanguageConfig[]): IConvertedRegionItem[] {
  // 输入验证
  if (!Array.isArray(data) || !Array.isArray(languageConfigs)) return [];

  // 构建语言映射表
  const languageMap = new Map<string, ILanguageConfig>();
  languageConfigs.forEach((config) => {
    if (config && config.code && config.name) {
      languageMap.set(config.code, config);
    }
  });

  // 转换语言列表的函数
  const convertLanguageList = (languageCodes: string[]): ILanguageConfig[] => {
    if (!Array.isArray(languageCodes)) return [];

    return languageCodes
      .filter((code) => typeof code === 'string' && code.trim() !== '')
      .map((code) => {
        const config = languageMap.get(code);
        return config ? { ...config } : { name: code, code };
      });
  };

  // 转换整个数据
  return data
    .filter((region) => region && typeof region === 'object')
    .map((region) => {
      const result: IConvertedRegionItem = {
        ...region,
        languageList: convertLanguageList(region.languageList),
        countryList: [],
      };

      // 处理国家列表
      if (Array.isArray(region.countryList)) {
        result.countryList = region.countryList
          .filter((country) => country && typeof country === 'object')
          .map((country) => ({
            ...country,
            languageList: convertLanguageList(country.languageList),
          }));
      }

      return result;
    });
}
